import { useEffect, useState } from "react";
import { useSettings } from "@/lib/useSettings";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Save } from "lucide-react";

export default function LiveMetaSettings() {
  const { data, save } = useSettings();
  const [f, setF] = useState(null);
  useEffect(() => { if (data) setF(data); }, [data]);
  if (!f) return <div className="text-slate-400">Lädt…</div>;

  const preview = `<meta name="robots" content="${f.robots}">
<meta name="title" content="${f.meta_title}">
<meta name="description" content="${f.meta_description}">
<meta name="keywords" content="${f.meta_keywords}">`;

  return (
    <div className="max-w-2xl space-y-6">
      <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm space-y-4">
        <h2 className="font-display text-lg font-bold text-slate-800">Live-URL / Domain</h2>
        <div>
          <Label>Live-URL</Label>
          <Input value={f.live_url} onChange={(e) => setF({ ...f, live_url: e.target.value })} className="mt-1 mono" placeholder="https://www.dein-magazin.de" data-testid="live-url" />
          <p className="text-xs text-slate-400 mt-1">Wird für passwortgeschützte Links in E-Mails und externe Widgets verwendet.</p>
        </div>
        <div>
          <Label>Freigabe-Label für Dashboard</Label>
          <Input value={f.dashboard_label} onChange={(e) => setF({ ...f, dashboard_label: e.target.value })} className="mt-1" placeholder="Dashboard" />
        </div>
        <Button onClick={() => save({ live_url: f.live_url, dashboard_label: f.dashboard_label })} className="bg-[#0B132B] hover:bg-[#1C2541]"><Save size={16} className="mr-1.5" /> Speichern</Button>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm space-y-4">
        <h2 className="font-display text-lg font-bold text-slate-800">Meta-Tags &amp; Suchmaschinen</h2>
        <div><Label>Seitentitel (Title-Tag)</Label><Input value={f.meta_title} onChange={(e) => setF({ ...f, meta_title: e.target.value })} className="mt-1" data-testid="meta-title" /></div>
        <div><Label>Beschreibung (Meta-Description)</Label><Textarea value={f.meta_description} onChange={(e) => setF({ ...f, meta_description: e.target.value })} className="mt-1" rows={2} /></div>
        <div><Label>Schlüsselwörter (kommagetrennt)</Label><Input value={f.meta_keywords} onChange={(e) => setF({ ...f, meta_keywords: e.target.value })} className="mt-1" /></div>
        <div>
          <Label>Robots-Anweisung</Label>
          <Select value={f.robots} onValueChange={(v) => setF({ ...f, robots: v })}>
            <SelectTrigger className="mt-1" data-testid="robots-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="noindex, nofollow">noindex, nofollow (empfohlen – nicht indexieren)</SelectItem>
              <SelectItem value="index, follow">index, follow (öffentlich indexieren)</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label className="text-xs uppercase tracking-wider text-slate-500">Vorschau</Label>
          <pre className="mt-1 bg-slate-900 text-slate-100 text-xs rounded-lg p-3 overflow-x-auto mono">{preview}</pre>
        </div>
        <Button onClick={() => save({ meta_title: f.meta_title, meta_description: f.meta_description, meta_keywords: f.meta_keywords, robots: f.robots })} className="bg-[#0B132B] hover:bg-[#1C2541]"><Save size={16} className="mr-1.5" /> Speichern</Button>
      </div>
    </div>
  );
}
